import TokenService from '../auth/generateToken.service';

import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';

export default async function authHeader() {

  const sessionDifference = timeSessionDifference();

  const timeTokenExpiredMax = Number(process.env.REACT_APP_TIME_EXPIRED_TOKEN)-5;
  const timeTokenExpiredMin = 10;

  if((sessionDifference < timeTokenExpiredMax) && (sessionDifference > timeTokenExpiredMin) ) {
    
    await Promise.resolve(TokenService.getRefreshToken());

      const user = JSON.parse(localStorage.getItem('client'));
  
      if (user && user.token) {
        return { Authorization: 'Bearer ' + user.token };
      } else {
        return {};
      }

  } else {

    const user = JSON.parse(localStorage.getItem('client'));
  
    if (user && user.token) {
      return { Authorization: 'Bearer ' + user.token };
    } else {
      return {};
    }
  }
}